'use client';

import { ReactNode } from 'react';

import { Footer } from '@/components/Footer/Footer';
import { ProfileMenuMobile } from '@/components/ProfileMenuMobile/ProfileMenuMobile';
import { TapBar } from '@/components/TapBar/TapBar';

import * as S from './PageWrapper.styles';

interface PageWrapperProps {
  children: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  tapBar?: ReactNode;
}

export const PageWrapper = ({
  children,
  header,
  footer,
  tapBar
}: PageWrapperProps) => {
  const hasTapBar = tapBar === undefined;

  const renderedFooter = footer === undefined ? <Footer /> : footer;
  const renderedTapBar = hasTapBar ? <TapBar /> : tapBar;

  return (
    <S.Wrapper $hasTapBar={hasTapBar}>
      {header}
      <ProfileMenuMobile />
      <S.MainContent>{children}</S.MainContent>
      {renderedFooter}
      {renderedTapBar}
    </S.Wrapper>
  );
};
